export const digitalLicenseStatus = Object.freeze({
  initialized: 10,
  ordered: 20,
  published: 80,
});
